import React from 'react';
import styled from 'styled-components';

import './styles.css';

const IconContainer = styled.i`
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'AzulIcons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

function Icon({ name, className, ...props }) {
    return (
      <IconContainer
        {...props}
        className={`icon-${name} ${(className || '')}`}
      />
    )
}

export default Icon;
